import { Body } from '@cognite/cogs.js-v10';
import { UnleashKeys } from '@infield/constants/unleash-keys';
import { useContext } from 'react';

import { AppConfigUseFlagContext } from '../app-config-use-flag.context';
import { LegacySaveButton } from '../legacy-save-button/legacy-save-button';
import { SaveConfigurationModalButton } from '../save-configuration-modal-button';

export type SaveConfigurationButtonProps = {
  onSave: () => Promise<void>;
  isDisabled: boolean;
  isLoading: boolean;
  hasButtonHelpText?: boolean;
  extraContent?: React.ReactNode;
};

export const SaveConfigurationButton = ({
  onSave,
  isDisabled,
  isLoading,
  hasButtonHelpText = false,
  extraContent,
}: SaveConfigurationButtonProps) => {
  const { useFlag } = useContext(AppConfigUseFlagContext);
  const { isEnabled: isConfigConfirmationEnabled } = useFlag(
    UnleashKeys.save_config_confirmation,
    {
      forceRerender: true,
      fallback: false,
    }
  );

  const { isEnabled: isSaveConfignDisabled } = useFlag(
    UnleashKeys.save_config_disabled,
    {
      forceRerender: true,
      fallback: false,
    }
  );

  if (isConfigConfirmationEnabled) {
    return (
      <SaveConfigurationModalButton
        isDisabled={isDisabled || isSaveConfignDisabled}
        isLoading={isLoading}
        onSave={onSave}
        hasButtonHelpText={hasButtonHelpText}
        extraContent={extraContent}
      />
    );
  }

  return (
    <LegacySaveButton
      onClick={onSave}
      disabled={isDisabled || isSaveConfignDisabled}
      loading={isLoading}
      hasButtonHelpText={hasButtonHelpText}
    />
  );
};
